import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider } from '@dixa/lib-shared-habla';
import { LauncherIcon } from './launcherIcon/LauncherIcon';
import { MessengerLogo } from './messengerLogo/MessengerLogo';
import { MessengerTheme } from './messengerTheme';
export const StyleSettings = ({ presetBackgrounds, backgroundColor, logo, }) => {
    return (_jsxs(Box, { children: [_jsx(MessengerTheme, { presetBackgrounds: presetBackgrounds, backgroundColor: backgroundColor }), _jsx(Box, Object.assign({ margin: "400 0" }, { children: _jsx(Divider, { size: "xSmall" }) })), _jsx(MessengerLogo, { logo: logo }), _jsx(Box, Object.assign({ margin: "400 0" }, { children: _jsx(Divider, { size: "xSmall" }) })), _jsx(LauncherIcon, {})] }));
};
